import { render, staticRenderFns } from "./DataDict.vue?vue&type=template&id=1c149c30&scoped=true"
import script from "./DataDict.vue?vue&type=script&lang=js"
export * from "./DataDict.vue?vue&type=script&lang=js"
import style0 from "./DataDict.vue?vue&type=style&index=0&id=1c149c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c149c30",
  null
  
)

export default component.exports